module.exports = __webpack_public_path__ + "img/img_phone_charge1.f3419e27.png";